"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');


var _HYJVIPVIcjs = require('../__chunks/HYJVIPVI.cjs');
require('../__chunks/MXJUUCSD.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-dismiss.tsx
var TagName = "button";
var useSelectDismiss = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectDismiss2({ store, ...props }) {
    const context = _AVNURAH2cjs.useSelectScopedContext.call(void 0, );
    store = store || context;
    props = _HYJVIPVIcjs.usePopoverDismiss.call(void 0, { store, ...props });
    return props;
  }
);
var SelectDismiss = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectDismiss2(props) {
  const htmlProps = useSelectDismiss(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.SelectDismiss = SelectDismiss; exports.useSelectDismiss = useSelectDismiss;
